import React, { useState, useEffect } from 'react';
import { Modal, Typography, Button, CircularButton } from '@hpi-sox/hpstellar-core';

import GameCard from './game-card';
import { pickFPS, formatFPS } from './util';

import './game-fps-modal.less';

const INITIAL_GAME_COUNT = 20;

export default function GameFPSModal({
    gameList,
    gameTitles,
    fpsData = {},
    graphicsPreset,
    selecting,
    selection,
    onSelection,
    onModalClose,
}) {
    const [visibleCount, setVisibleCount] = useState(INITIAL_GAME_COUNT);
    const disable = selection.length > 4;

    useEffect(() => {
        if (selecting) {
            setVisibleCount(INITIAL_GAME_COUNT);
        }
    }, [selecting]);

    const visibleGameList = gameList.slice(0, visibleCount);

    const gameSelected = game => {
        const selected = selection.some(s => s.id === game.id);
        const newSelection = selected ? selection.filter(s => s.id !== game.id) : [...selection, game];
        onSelection(newSelection);
    };

    const onClose = () => {
        onModalClose();
    };

    return (
        <Modal
            className="gameFPSModal"
            isOpen={selecting}
            animationType="fade-in"
            aria-describedby="modal-description"
            aria-labelledby="modal-title"
            horizontalAlignment="center"
            verticalAlignment="center"
            withBackdrop
        >
            <div className="modalContent">
                <div className="modalHeader">
                    <Typography className="title" variant="titleM">
                        Select up to 5 Games
                    </Typography>
                    <CircularButton icon="cross" size="small" onClick={onClose} />
                </div>
                <div className="gameGrid">
                    {visibleGameList.map(game => {
                        const selected = selection.some(s => s.id === game.id);
                        const gamePreset = game.preset?.[graphicsPreset] || graphicsPreset;
                        return (
                            <GameCard
                                {...game}
                                fps={
                                    //show the selected preset label (High/Medium/Low), not the internal mapped value used for the API payload
                                    formatFPS(fpsData[game.id], graphicsPreset) || pickFPS(game, gameTitles, gamePreset)
                                }
                                selected={selected}
                                key={game.id}
                                disable={disable && !selected}
                                onToggle={() => gameSelected(game)}
                            />
                        );
                    })}
                    {visibleCount < gameList.length && (
                        <Button
                            className="loadMoreBtn"
                            size="small"
                            color="dark"
                            variation="secondary"
                            onClick={() => setVisibleCount(count => count + INITIAL_GAME_COUNT)}
                        >
                            LOAD MORE
                        </Button>
                    )}
                </div>
            </div>
        </Modal>
    );
}
